module.exports = __webpack_public_path__ + "img/wallet-t-pay.4a7ba5cb.svg";